import React, { Fragment, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { FaTrash } from "react-icons/fa";
import axios from "axios";
import { getToken } from '../../auth/authConfig';

export default function DeleteUsers({ email, getUserList }) {
  const [open, setOpen] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [issuccess, setsuccess] = useState(false);
  const [iserror, seterror] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = async () => {
    setIsloading(true);
    const token = await getToken();

    const url = `${process.env.REACT_APP_SERVER_URL}/api/user/deleteUser`;
    const header = {
      headers: {
        "oidc-token": token,
      },
    };

    const data = {
      email: email,
    };

    axios
      .post(url, data, header)

      .then(function (response) {
        if (response.status === 200) {
          // console.log(response);
          setIsloading(false);
          setsuccess(true);
          getUserList();
          setTimeout(() => {
            setsuccess(false);
          }, 5000);
        }
      })
      .catch(function (error) {
        // console.log(error);
        setIsloading(false);
        seterror(true);
        setTimeout(() => {
          seterror(false);
        }, 5000);
      });
  };

  return (
    <Fragment>
      <div onClick={handleClickOpen}>
        <FaTrash className="deletecls" title="Delete" color="red" />
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure you want to delete this user?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Once deleted, the action cannot be undone, and this <b>{email}</b>{" "}
            associated data will be permanently removed. Please confirm if you
            wish to proceed
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="reset_btn" onClick={handleClose}>
            No
          </Button>

          <Button
            disabled={isLoading}
            className="submit_btn"
            type="submit"
            onClick={handleDelete}
          >
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span style={{ paddingLeft: "10px" }}>Deleting..</span>
              </>
            ) : (
              "Yes"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
